import { Map } from './components/map/map';
import { OrganigramComponent } from './components/organigram/organigram-component';
import { HtmlComponent } from './components/html-component';
import { CommandManager } from './commands/command-manager';
import { Legend } from './components/legend/legend';

// import html
import template from './gui.hogan.html';
import { ContextDetailComponent } from './components/context-detail/context-detail-component';
import { DataSourceLoader } from '@/data-management/data-sources/loader/data-source-loader';
import { DataFiltersLoader } from '@/data-management/data-filters/loader/data-filters-loader';
import store from '@/store/store';

export class Gui extends HtmlComponent {
    public map: Map;
    public app: { dataSourceLoader: DataSourceLoader; dataFiltersManager: DataFiltersLoader };
    public commandManager: CommandManager;

    // private personGridComponent: PersonGridComponent;
    public contextDetail: ContextDetailComponent;
    public organigramComponent: OrganigramComponent;
    private legend: Legend;

    constructor() {
        super(template, {});
        const dataSourceLoader = new DataSourceLoader();
        store.state.dataSourceLoader = dataSourceLoader;
        const dataFiltersManager = new DataFiltersLoader(dataSourceLoader);
        store.state.dataFiltersManager = dataFiltersManager;
        this.app = {
            dataSourceLoader,
            dataFiltersManager
        };
        this.commandManager = new CommandManager(this);
        store.state.commandManager = this.commandManager;
    }

    init() {
        this.addToJqueryTag('#app .overview-container-legacy');
        this.map = new Map(this);
        this.map.addToJqueryTag('#map-placeholder', this);
        this.map.init();

        this.contextDetail = new ContextDetailComponent(this);
        this.contextDetail.addToJqueryTag('#context-detail-placeholder', this);
        this.contextDetail.init();

        this.organigramComponent = new OrganigramComponent(this);
        this.organigramComponent.addToJqueryTag('#organigram-placeholder', this);
        const organigramFinishedPromise = this.organigramComponent.init();

        this.legend = new Legend(this);
        this.legend.addToJqueryTag('#legend-placeholder', this);

        organigramFinishedPromise.then(() => {
            setTimeout(() => {
                if (this.app.dataSourceLoader.authenticatedEmployee) {
                    this.commandManager.selectUserCommandExecutor.requestExecute({
                        userId: this.app.dataSourceLoader.authenticatedEmployee._internal_datasource_id_
                    });
                }
            }, 1000);
        });

        this.checkSizeChanged();
        return organigramFinishedPromise;
    }

    private checkSizeChanged() {
        let timeoutId: any;
        window.addEventListener('resize', () => {
            // Throttle resize event
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                this.organigramComponent.resize();
                this.contextDetail.resize();
                timeoutId = undefined;
            }, 50);
        });
    }
}
